export default __webpack_public_path__ + "static/media/3Klein.811214e3.jpg";